import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorHandler, enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideServiceWorker } from '@angular/service-worker';
import { GlobalErrorHandler } from '@navfleet/app/handlers/global-error-handler';
import { AppHttpInterceptor } from '@navfleet/app/interceptors/app-http.interceptor';
import { HttpErrorInterceptor } from '@navfleet/app/interceptors/http-error.interceptor';
import { themePreset } from '@navfleet/app/theme';
import { FORMAT_DATE_OPTIMUS } from '@navfleet/client/shared/constants/app';
import { ToasterService } from '@navfleet/client/shared/services/toast';
import { ClientShellModule } from '@navfleet/client/shell/feature/shell';
import { TenantInterceptor } from '@navfleet/client/tenant/domain/data-access';
import { environment } from '@navfleet/shared/core/environment';
import { TranslationModule } from '@navfleet/shared/core/translation';
import { ConfirmationService, MessageService } from '@openng/optimus-ui/api';
import { provideOptimus } from '@openng/optimus-ui/config';
import { DialogService } from '@openng/optimus-ui/dynamicdialog';
import { provideHighcharts } from 'highcharts-angular';
import { setWorkerUrl } from 'maplibre-gl';
import { AppComponent } from './app/app.component';

const ERROR_HANDLERS = [
    {
        provide: ErrorHandler,
        useClass: GlobalErrorHandler,
    },
];

const INTERCEPTORS = [
    {
        provide: HTTP_INTERCEPTORS,
        useClass: HttpErrorInterceptor,
        multi: true,
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: AppHttpInterceptor,
        multi: true,
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: TenantInterceptor,
        multi: true,
    },
];

if (environment.production) {
    enableProdMode();
}

setWorkerUrl(new URL('assets/maplibre-gl-worker.mjs', document.baseURI).href);

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideServiceWorker('ngsw-worker.js', {
            enabled: environment.ENABLE_SERVICE_WORKER,
        }),
        importProvidersFrom(TranslationModule.forRoot(), ClientShellModule),
        ...ERROR_HANDLERS,
        ...INTERCEPTORS,
        ConfirmationService,
        MessageService,
        DialogService,
        ToasterService,
        provideHttpClient(withFetch(), withInterceptorsFromDi()),
        provideOptimus({
            theme: {
                preset: themePreset,
                options: {
                    darkModeSelector: '.dark-mode',
                },
            },
            translation: {
                dateFormat: FORMAT_DATE_OPTIMUS,
            },
        }),
        provideHighcharts(),
    ],
}).catch((err) => console.error(err)); // eslint-disable-line no-console
